import React, { useState, useCallback } from 'react';
import { Grid } from '@giphy/react-components';
import { GiphyFetch } from '@giphy/js-fetch-api';
import './GifPicker.css';

interface GifPickerProps {
  onSelect: (gifUrl: string) => void;
  onClose: () => void;
}

const gf = new GiphyFetch('fPYSvwWoLCrZHILx7pXCYhjfMsHtBZ3t'); // Replace with your actual GIPHY API key

const GifPicker: React.FC<GifPickerProps> = ({ onSelect, onClose }) => {
  const [search, setSearch] = useState('');

  const fetchGifs = useCallback((offset: number) => {
    return search
      ? gf.search(search, { offset, limit: 10 })
      : gf.trending({ offset, limit: 10 });
  }, [search]);

  const handleGifClick = (gif: any, e: React.SyntheticEvent<HTMLElement, Event>) => {
    e.preventDefault();
    onSelect(gif.images.original.url);
    onClose();
  };

  return (
    <div className="gif-picker">
      <div className="gif-picker-header">
        <input
          type="text"
          placeholder="Search GIFs"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="gif-search-input"
        />
        <button onClick={onClose} className="gif-close-button">Close</button>
      </div>
      <div className="gif-grid">
        <Grid
          key={search} // Force re-render on search change
          width={300}
          columns={3}
          fetchGifs={fetchGifs}
          onGifClick={handleGifClick}
          noLink={true}
        />
      </div>
    </div>
  );
};

export default GifPicker;
